import React from 'react';
import { Button, Typography } from "@mui/material";
import { Modal } from "react-responsive-modal";

const PopUp = ({title,
    message,
    yesText = "Ok",
    noText = "Cancel",
    yesColor = "primary",
    noColor = "error",
    handleYes = () => {},
    handleNo = () => {},
    open = false,
    setOpen,
}) => {
    return (
        <Modal
        open={open}
        onClose={() => setOpen(false)}
        center
      >
    <div className="p-8 flex flex-col items-center gap-4">
            <div className="flex flex-col items-center gap-2">
                <Typography variant="h5" color="textPrimary" fontWeight={600}>
                    {title}
                </Typography>
                <Typography variant="body1" color="textSecondary">
                    {message}
                </Typography>
            </div>
            <div className="flex flex-row justify-between gap-4">
                <Button variant="contained" color={yesColor} onClick={handleYes}>
                    {yesText}
                </Button>
                <Button variant="contained" color={noColor} onClick={handleNo}>
                    {noText}
                </Button>
            </div>
    </div>
    </Modal>
    );
}

export default PopUp;